
<template>
     <div :class="this.getSlideshowClasses" ref="slider">
        <div class="swiper-wrapper">
            <template v-for="(slide, index) in slides">
                <div class="slideshow__slide swiper-slide" :key="`slideshow-slide-${index}`">
                    <media-element
                        v-if="slide.media"
                        :media="slide.media"
                        @loaded="handleMediaLoaded"
                    ></media-element>
                    <div v-if="slide.introtext" class="slideshow__text-container">
                        <div class="slideshow__page-container">
                            <div class="slideshow__content-container">
                                <div class="slideshow__grid">
                                    <div class="slideshow__grid-column slideshow__grid-column--text">
                                        <introtext-element
                                            @loaded="handleTextLoaded"
                                            type="type-2"
                                            :introtext="slide.introtext"
                                        ></introtext-element>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="swiper-no-swiping slideshow__button-prev swiper-button-prev"><svgicon name="lined-arrow-right" dir="left" color="#ffffff"/></div>
        <div class="swiper-no-swiping slideshow__button-next swiper-button-next"><svgicon name="lined-arrow-right" dir="right" color="#ffffff"/></div>

        <div class="swiper-pagination"></div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import debounce from 'debounce';

export default {
    name: 'SlideshowElement',
    props: {
        slides: Array,
        settings: {
            type: Object,
            default: () => {
                return {
                    layout: 'text-under-image',
                    loop: false,
                    mode: 'slide'
                }
            }
        }
    },
    data() {
        return {
            slider: null
        }
    },
    computed: {
        getSlideshowClasses() {
            return {
                'slideshow' : true,
                'swiper-container': true,
                [`slideshow--layout-${this.settings.layout}`]: true,
            }
        }
    },
    async mounted() {
        await this.$nextTick();

        this.createSlider();
    },
    methods: {
        createSlider() {
            const { slider } = this.$refs;

            this.slider = new Swiper(slider, {
                effect: this.settings.mode,
                loop: this.settings.loop,
                preventClicks: false,
                watchOverflow: true,
                autoHeight: true,
                slideToClickedSlide: false,
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                }
            });

            this.slider.on('resize', () => {
                this.slider.update();
            });
        },

        handleMediaLoaded() {
            this.slider && this.slider.update();
        },

        handleTextLoaded: debounce(function () {
            this.slider && this.slider.destroy();
            this.createSlider();
        }, 10),
    },
    beforeDestroy() {
        this.slider && this.slider.destroy();
    }
}
</script>

